import {
  CREATE_MANUAL_BOOKING,
  CREATE_MANUAL_BOOKING_SUCCESS,
  CREATE_MANUAL_BOOKING_ERROR,
  CREATE_MANUAL_BOOKING_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateManualBooking = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_MANUAL_BOOKING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_MANUAL_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_MANUAL_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case CREATE_MANUAL_BOOKING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateManualBooking;
